/**
 * changeImpactsApi — CR-2026-DC-IMPACT-REVIEW (D-032 §10).
 */

import ApiCall from './apicall';

export const IMPACT_STATUSES = ['OPEN', 'IN_REVIEW', 'DISPOSITIONED', 'HELD', 'CLOSED', 'CANCELLED'];
export const IMPACT_RISK = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
export const IMPACT_DISPOSITIONS = [
  'PROCEED_AS_IS', 'REWORK', 'REPAIR', 'REMAKE',
  'USE_AS_IS_WITH_APPROVAL', 'FIELD_MOD', 'NCR_OPENED',
];
export const AFFECTED_STAGES = [
  'NOT_ISSUED', 'ISSUED', 'IN_FAB', 'QC_PASSED', 'READY_TO_SHIP',
  'LOADED', 'SHIPPED', 'INSTALLED',
];

const ALLOWED_TRANSITIONS = {
  OPEN:          ['IN_REVIEW', 'HELD', 'CANCELLED'],
  IN_REVIEW:     ['DISPOSITIONED', 'HELD', 'CANCELLED'],
  DISPOSITIONED: ['CLOSED', 'HELD'],
  HELD:          ['IN_REVIEW', 'DISPOSITIONED', 'CANCELLED'],
  CLOSED:        [],
  CANCELLED:     [],
};
export const allowedImpactTransitions = (status) => ALLOWED_TRANSITIONS[status] || [];

export async function listImpacts(filters = {}) {
  const params = new URLSearchParams();
  if (filters.job_id) params.set('job_id', filters.job_id);
  if (filters.status) params.set('status', filters.status);
  if (filters.hold_active) params.set('hold_active', '1');
  if (filters.document_id) params.set('document_id', filters.document_id);
  if (filters.limit) params.set('limit', filters.limit);
  const qs = params.toString();
  const { data } = await ApiCall.get(`/change-impacts${qs ? `?${qs}` : ''}`);
  return data;
}

export async function getImpact(id) {
  const { data } = await ApiCall.get(`/change-impacts/${id}`);
  return data;
}

export async function createImpact(payload) {
  const { data } = await ApiCall.post('/change-impacts', payload);
  return data;
}

export async function addAffectedPieces(id, affected_pieces) {
  const { data } = await ApiCall.post(`/change-impacts/${id}/affected`, { affected_pieces });
  return data;
}

export const startImpactReview = async (id) => (await ApiCall.post(`/change-impacts/${id}/start-review`)).data;
export const dispositionImpact = async (id, body) => (await ApiCall.post(`/change-impacts/${id}/disposition`, body)).data;
export const placeImpactHold = async (id, hold_reason) => (await ApiCall.post(`/change-impacts/${id}/hold`, { hold_reason })).data;
// CR-2026-BE-DC-DECISION-INTEGRITY: the server now requires and audits a lift reason.
export const liftImpactHold = async (id, lift_reason) => (await ApiCall.post(`/change-impacts/${id}/lift-hold`, { lift_reason })).data;
export const closeImpact = async (id) => (await ApiCall.post(`/change-impacts/${id}/close`)).data;
export const cancelImpact = async (id, cancel_reason) => (await ApiCall.post(`/change-impacts/${id}/cancel`, { cancel_reason })).data;
